<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          text
          v-on="on"
        >
          ¿Olvidaste tu contraseña?
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Recuperar Contraseña
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="email"
              label="Email"
              class="purple-input"
              prepend-icon="mdi-email"
              :rules="emailRules"
              outlined
            />
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="reset"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        email: '',
        emailRules: [
          value => !!value || 'Email es requerido.',
          value => (value || '').length <= 50 || 'Max 50 caracteres',
          value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Email invalido.'
          },
        ],
      }
    },
    watch: {
      dialog (val) {
        val && (this.email = '')
      },
    },
    methods: {
      reset () {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('SEND_FORGOT_EMAIL', this.email)
          this.dialog = false
        } else {
          console.log('Faltan datos')
        }
      },
    },
  }
</script>
